import React from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import DownloadIcon from "@mui/icons-material/Download";

const FilterExportButtons = ({
  clearFilters,
  exportToPDF,
  exportToExcel,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      justifyContent="end"
      gap={2}
      m={1}
    >
      <Button
        variant="contained"
        onClick={clearFilters}
        startIcon={<ClearAllIcon />}
        sx={{
          backgroundColor: "rgba(244,151,3,.8)",
          color: "rgb(20,61,89)",
        }}
      >
        Clear
      </Button>

      <div>
        <Button
          variant="contained"
          id="demo-positioned-button"
          aria-controls={open ? "demo-positioned-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          startIcon={<DownloadIcon />}
          sx={{
            backgroundColor: "rgba(244,151,3,.8)",
            color: "rgb(20,61,89)",
            "&:hover": {
              backgroundColor: "rgba(244,151,3,.8)",
              color: "rgb(20,61,89)",
            },
          }}
        >
          Export
        </Button>

        <Menu
          id="demo-positioned-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem
            onClick={() => {
              exportToPDF();
              handleMenuClose();
            }}
          >
            PDF
          </MenuItem>
          <MenuItem
            onClick={() => {
              exportToExcel();
              handleMenuClose();
            }}
          >
            Excel
          </MenuItem>
        </Menu>
      </div>
    </Box>
  );
};

export default FilterExportButtons;
